import { Api, domain } from "@relode/core";

import { JobPositionsSuggestRequest } from ".";

export const jobPositionLookupService = {
    loadSuggestions: async (
        criteria: JobPositionsSuggestRequest,
        signal?: AbortSignal
    ): Promise<domain.JobPosition[]> => {
        const url = "/jobpositions/suggest";
        const result = await Api.url(url)
            .body({
                ...criteria,
            })
            .retries(3)
            .useSignal(signal)
            .track({ name: "suggest", data: { criteria } })
            .post<domain.JobPosition[]>();
        return result;
    },
};
